import { render, staticRenderFns } from "./AddClassify.vue?vue&type=template&id=b0e3a812&scoped=true"
import script from "./AddClassify.vue?vue&type=script&lang=js"
export * from "./AddClassify.vue?vue&type=script&lang=js"
import style0 from "./AddClassify.vue?vue&type=style&index=0&id=b0e3a812&prod&lang=scss&scoped=true"
import style1 from "./AddClassify.vue?vue&type=style&index=1&id=b0e3a812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e3a812",
  null
  
)

export default component.exports